import React from 'react';

const CoursesOffer = () => {
  const courses = [
    {
      img: './images/web dev.jpg',
      category: 'FULL-STACK',
      title: 'WEB DEVELOPMENT',
      duration: '6 months',
      fee: '7000/-PKR',
    },
    {
      img: './images/app dev.jpg',
      category: 'FULL-STACK',
      title: 'APP DEVELOPMENT',
      duration: '6 months',
      fee: '8,500/-PKR',
    },
    {
      img: './images/ai.jpg',
      category: 'FULL COURSE',
      title: 'ARTIFICIAL INTELLIGENCE',
      duration: '6 months',
      fee: '7,500/-PKR',
    },
    {
      img: './images/digi.jpg',
      category: 'FULL COURSE',
      title: 'DIGITAL MARKETING',
      duration: '3 months',
      fee: '6500/-PKR',
    },
    {
      img: './images/machine.jfif',
      category: 'FULL COURSE',
      title: 'MACHINE LEARNING',
      duration: '3 months',
      fee: '8000/-PKR',
    },
    {
      img: './images/python.jfif',
      category: 'FULL COURSE',
      title: 'PYTHON',
      duration: '3 months',
      fee: '7000/-PKR',
    },
    {
      img: './images/amazon.jpg',
      category: 'FBA/FBM',
      title: 'AMAZON',
      duration: '3 months',
      fee: '10,000/-PKR',
    },
    {
      img: './images/freelance.jfif',
      category: 'FULL COURSE',
      title: 'FREELANCING',
      duration: '3 months',
      fee: '7000/-PKR',
    },
    {
      img: './images/programming.jpg',
      category: 'ANY PROGRAMMING LANGUAGE',
      title: 'ALL LANGUAGES',
      duration: '3 months',
      fee: '7000/-PKR',
    },
    {
      img: './images/msoffice.jpg',
      category: 'FULL COURSE',
      title: 'MS OFFICE',
      duration: '2 months',
      fee: '5000/-PKR',
    },
    {
      img: './images/computer.webp',
      category: 'FULL COURSE',
      title: 'COMPUTER COURSE',
      duration: '3 months',
      fee: '5000/-PKR',
    },
    {
      img: './images/graphics.jfif',
      category: 'FULL COURSE',
      title: 'GRAPHIC DESIGNING',
      duration: '3 months',
      fee: '6000/-PKR',
    },
    {
      img: './images/spoken.jfif',
      category: 'FULL COURSE',
      title: 'SPOKEN ENGLISH',
      duration: '3 months',
      fee: '6000/-PKR',
    },
    {
      img: './images/video.jfif',
      category: 'FULL COURSE',
      title: 'VIDEO EDITING',
      duration: '3 months',
      fee: '6000/-PKR',
    },
  ];

  return (
    <div className='py-10 px-4 sm:px-6 md:px-20'>
      <section className="text-gray-600 body-font">
        <div className="container px-1 py-1 mx-auto">
          <div className="text-center mb-20" data-aos="fade-up">
            <h2 className="title-font sm:text-4xl text-3xl mb-6 font-semibold text-gray-900">
              On-Campus & Online Courses We Offer
            </h2>
            <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto text-gray-700">
              At <span className="text-lg text-[#d09714]">EZ Technologies</span>, we offer cutting-edge <span className="text-lg text-[#d09714]">digital skills</span> training designed to meet the demands of the modern world. Whether you prefer learning from the comfort of your home or in a classroom setting, our courses are available in both online and offline formats to ensure flexibility and accessibility for all learners.
            </p>
            <div className="flex mt-6 justify-center">
              <div className="w-16 h-1 rounded-full bg-[#d09714] inline-flex"></div>
            </div>
          </div>

          <div className="flex flex-wrap -m-4">
            {courses.map((course, index) => (
              <div key={index} className="lg:w-1/4 md:w-1/2 p-4 w-full" data-aos="zoom-in">
                <div className="block relative w-11/12 h-48 rounded overflow-hidden mx-auto">
                  <img
                    alt={course.title}
                    className="object-cover object-center w-full h-full"
                    src={course.img}
                  />
                </div>
                <div className="mt-4 text-center">
                  <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">{course.category}</h3>
                  <h2 className="text-[#d09714] title-font text-lg font-semibold">{course.title}</h2>
                  <p className="mt-1">Duration: {course.duration}</p>
                  <p className="mt-1">Monthly Fee: {course.fee}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CoursesOffer;
